/**
 * Admin home component fetch all post from database and displays also filter and delete posts
 */

import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import * as placesActions from "../../../store/admin";
import { bindActionCreators } from "redux";
import { GridLoader } from "react-spinners";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { css } from "@emotion/core";
import { config } from "../../../config/config";
import "react-notifications/lib/notifications.css";
import { deviceDetect } from "react-device-detect";
import { utilService } from "../../../common/utils";
import { DialogBox } from "../../../common/dialogbox";

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

class Places extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_data: {
        show: false,
      },
      filterData: {},
      delete: "Place",
      isLoading: false,
      isReseting: false,
      isFitering: false,
      isDeleating: false,
      errors: {},
    };
    this.actionsButtonFormatter = this.actionsButtonFormatter.bind(this);
    this.pagesActionsButtonFormatter = this.pagesActionsButtonFormatter.bind(
      this
    );
    this.onInputChange = this.onInputChange.bind(this);
    this.onReset = this.onReset.bind(this);
    this.onFilter = this.onFilter.bind(this);
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */

  componentDidMount() {
    // google analytic page view
    utilService.pageView();

    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "admin-places",
      title: "Admin Places",
      browserName: browserName,
      osName: osName,
      pageType: "Admin Places Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    // fetch places
    this.props.fetchPlaces({
      token: this.props.token,
      params: "",
    });
    // get page types
    this.props.fetchPageTypes({
      token: this.props.token,
      params: "",
    });
    // fetch pages
    this.props.fetchPages({
      token: this.props.token,
      params: "",
    });
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs.
   * @param {*} prevProps : Getting previous props
   * @param {*} prevState : Getting previous state
   */
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.placeActionLoading && !this.props.placeActionLoading) {
      if (prevState.isDeleating) {
        this.setState(
          {
            isLoading: false,
            isDeleating: false,
          },
          function () {
            // fetch pages
            this.props.fetchPages({
              token: this.props.token,
              params: "",
            });
            NotificationManager.success(
              "Success message",
              "Place deleted successfully."
            );
          }
        );
      }
    }
    if (prevProps.pageActionLoading && !this.props.pageActionLoading) {
      if (prevState.isDeleating) {
        this.setState(
          {
            isLoading: false,
            isDeleating: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "Page deleted successfully."
            );
          }
        );
      }
      if (prevState.isReseting) {
        this.setState({
          isLoading: false,
          isReseting: false,
        });
      }

      if (prevState.isFitering) {
        this.setState({
          isLoading: false,
          isFitering: false,
        });
      }
    }
  }

  /**
   * Update state on filter input change
   */
  onInputChange(e) {
    const { name, value } = e.target;
    let fields = this.state.filterData;
    if (name === "navigation") {
      fields[name] = e.target.checked;
    } else {
      fields[name] = value;
    }
    this.setState({
      fields,
    });
  }

  onEditPlace(cell, row, rowIndex) {
    this.props.onEditPlaceButton("/admin/edit-place/" + row.placeUid);
  }
  onEditPage(cell, row, rowIndex) {
    this.props.onEditPlaceButton("/admin/edit-page/" + row.pageUid);
  }
  onDeletePlace(cell, row, rowIndex) {
    if (row.placeUid) {
      this.setState({
        ...this.state,
        delete: "Place",
        modal_data: {
          ...this.state.modal_data,
          show: true,
          data: {
            heading: "Delete Place",
            body: "Are you sure you want to permanetly remove this place ?",
            rowId: row.placeUid,
          },
        },
      });
    }
  }
  onDeletePage(cell, row, rowIndex) {
    if (row.pageUid) {
      this.setState({
        ...this.state,
        delete: "Page",
        modal_data: {
          ...this.state.modal_data,
          show: true,
          data: {
            heading: "Delete Page",
            body: "Are you sure you want to permanetly remove this page ?",
            rowId: row.pageUid,
          },
        },
      });
    }
  }
  OnDialogSubmit(id) {
    this.setState(
      {
        ...this.state,
        modal_data: {
          ...this.state.modal_data,
          show: false,
        },
        isLoading: true,
        isDeleating: true,
      },
      function () {
        if (this.state.delete === "Place") {
          this.props.deletePlace({
            id: id,
            token: this.props.token,
          });
        } else {
          this.props.deletePage({
            id: id,
            token: this.props.token,
          });
        }
      }
    );
  }
  handleCloseModal() {
    this.setState({
      ...this.state,
      modal_data: {
        ...this.state.modal_data,
        show: false,
      },
    });
  }

  /**
   *
   * @param {*} e
   */
  onFilter(e) {
    e.preventDefault();
    let fields = this.state.filterData;
    let params = "?";
    if (fields['place']  && fields['place'] !== "Select Place") {
      if (params !== "?") {
        params = params + "&";
      }
      params = params + `place=${fields["place"]}`;
    }
    if (fields['pagetype'] && fields['pagetype'] !== "Select Page Type") {
      if (params !== "?") {
        params = params + "&";
      }
      params = params + `pagetype=${fields["pagetype"]}`;
    }
    if (fields["navigation"]) {
      if (params !== "?") {
        params = params + "&";
      }
      params = params + `navigation=${fields["navigation"]}`;
    }
    if (fields["title_keyword"]) {
      if (params !== "?") {
        params = params + "&";
      }
      params = params + `title_keyword=${fields["title_keyword"]}`;
    }
    if (params === "?") {
      params = "";
    }
    this.setState({
      isLoading: true,
      isFitering: true,
      isReseting: false,
    });
    if (fields['place']) {
      if (fields['place'] !== "Select Place") {
        this.props.fetchPlaces({
          token: this.props.token,
          params: params,
        });
        if (!fields['pagetype']) {
          this.props.fetchPages({
            token: this.props.token,
            params: params,
          });
        }
      } else if (fields['place'] === "Select Place") {
        this.props.fetchPlaces({
          token: this.props.token,
          params: "",
        });
        if (!fields['pagetype']) {
          this.props.fetchPages({
            token: this.props.token,
            params: "",
          });
        }
      }
    }
    if (fields['pagetype']) {
      if (fields['pagetype'] !== "Select Page Type") {
        this.props.fetchPages({
          token: this.props.token,
          params: params,
        });
      } else if (fields['pagetype'] === "Select Page Type") {
        this.props.fetchPages({
          token: this.props.token,
          params: "",
        });
      }
    }
    if (fields['navigation']) {
      this.props.fetchPages({
        token: this.props.token,
        params: params,
      });
    }
  }

  onReset(e) {
    e.preventDefault();
    this.setState({
      filterData: {},
      isLoading: true,
      isFitering: false,
      isReseting: true,
      errors: {},
    });
    this.myFormRef.reset();
    this.props.fetchPages({
      token: this.props.token,
      params: "",
    });
    this.props.fetchPlaces({
      token: this.props.token,
      params: '',
    });
  }
  actionsButtonFormatter(cell, row, enumObject, rowIndex) {
    return (
      <div className="d-flex align-items-center nav-con">
        <button
          type="button"
          className="bg-dark filter-btn width-btn"
          onClick={() => this.onEditPlace(cell, row, rowIndex)}
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          className="bg-primary filter-btn width-btn"
          onClick={() => this.onDeletePlace(cell, row, rowIndex)}
        >
          <i className="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    );
  }
  pagesActionsButtonFormatter(cell, row, enumObject, rowIndex) {
    return (
      <div className="d-flex align-items-center nav-con">
        <button
          type="button"
          className="bg-dark filter-btn width-btn"
          onClick={() => this.onEditPage(cell, row, rowIndex)}
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          className="bg-primary filter-btn width-btn"
          onClick={() => this.onDeletePage(cell, row, rowIndex)}
        >
          <i className="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    );
  }

  render() {
    const { pageTypes } = this.props;
    const places = this.props.places && this.props.places.length > 0 ? this.props.places.sort((a, b) => a.place.localeCompare(b.place)) : []
    const pages = this.props.pages && this.props.pages.length > 0 ? this.props.pages.sort((a, b) => a.place_place.localeCompare(b.place_place)) : []
    const placesDropList = this.props.placesDropList && this.props.placesDropList.length > 0 ? this.props.placesDropList.sort((a, b) => a.place.localeCompare(b.place)) : []
    // console.log("Pages.....", pages);

    const columns = [
      {
        dataField: "place",
        text: "Place",
      },
      {
        dataField: "description",
        text: "Description",
      },
      {
        dataField: "intended_audience",
        text: "Audience",
      },
      {
        dataField: "button",
        text: "Actions",
        formatter: this.actionsButtonFormatter,
      },
    ];
    const PagesColumns = [
      {
        dataField: "place_place",
        text: "Place",
      },
      {
        dataField: "title",
        text: "Title",
      },
      {
        dataField: "pagetype_pagetype",
        text: "Page Type",
      },
      {
        dataField: "navigation",
        text: "Navigation",
        formatter: navigationFormatter,
      },
      {
        dataField: "button",
        text: "Actions",
        formatter: this.pagesActionsButtonFormatter,
      },
    ];
    const placeList = places && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="placeUid"
          wrapperClasses="table-responsive"
          data={places.sort((a) => a.place)}
          loading={true}
          columns={columns}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );
    const pageList = pages && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="pageUid"
          wrapperClasses="table-responsive"
          data={pages}
          loading={true}
          columns={PagesColumns}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );
    return (
      <div>
        <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
          <h1>CREATE NEW</h1>
          <div className="d-flex">
            <NavLink to="/admin/add-place">
              <button className="mr-1">Place</button>
            </NavLink>
            <NavLink to="/admin/add-page">
              <button className="mr-1">Page</button>
            </NavLink>
          </div>
        </div>
        <div className="filters mb-2">
          <form ref={(el) => (this.myFormRef = el)}>
            <h2>Filters</h2>
            <div className="brd-1">
              <div className="row">
                <div className="col-md-6">
                  <div className="recepient pb-5">
                    <p className="datetext">Place</p>
                    <label className="d-flex flex-column">
                      <select
                        className="form-control"
                        name="place"
                        onChange={this.onInputChange}
                        value={this.state.filterData.place || "Select Place"}
                      >
                        <option value="Select Place">Select Place</option>
                        {placesDropList &&
                          placesDropList.map((item, index) => (
                            <option key={item.placeUid} value={item.placeUid}>
                              {item.place}
                            </option>
                          ))}
                      </select>
                    </label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="recepient pb-5">
                    <p className="datetext">Page Type</p>
                    <label className="d-flex flex-column">
                      <select
                        className="form-control"
                        name="pagetype"
                        onChange={this.onInputChange}
                        value={this.state.filterData.pagetype || "Select Page Type"}
                      >
                        <option value="Select Page Type">Select Page Type</option>
                        {pageTypes &&
                          pageTypes.map((item, index) => (
                            <option
                              key={item.pagetypeUid}
                              value={item.pagetypeUid}
                            >
                              {item.pageType}
                            </option>
                          ))}
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="brd-1">
              <div className="row">
                <div className="col-md-6">
                  <label className="typecheck">
                    Navigation
                    <input
                      type="checkbox"
                      name="navigation"
                      onChange={this.onInputChange}
                      checked={this.state.filterData.navigation ? true : false}
                    />
                    <span className="typemark"></span>
                  </label>
                </div>
                <div className="col-md-6">
                  <div className="date pb-2">
                    {/* <p className="datetext">Title Keyword</p>
                    <input
                      name="title_keyword"
                      type="text"
                      className="form-control"
                      onChange={this.onInputChange}
                      value={this.state.filterData.title_keyword || ""}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between pt-1 flex-column flex-lg-row">
              <div className="">
                {this.state.isReseting && this.state.isLoading && (
                  <button
                    disabled={this.state.isLoading}
                    onClick={this.onReset}
                    className="btn-secondary filter-btn"
                  >
                    Reset ...
                  </button>
                )}
                {!this.state.isReseting && (
                  <button
                    onClick={this.onReset}
                    className="btn-secondary filter-btn"
                  >
                    Reset
                  </button>
                )}
                {this.state.isLoading && this.state.isFitering && (
                  <button
                    disabled={this.state.isLoading}
                    onClick={this.onFilter}
                    className="btn-secondary filter-btn"
                  >
                    Filter ...
                  </button>
                )}
                {!this.state.isFitering && (
                  <button
                    onClick={this.onFilter}
                    className="btn-secondary filter-btn"
                  >
                    Filter
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
        {this.props.placeActionLoading === true && (
          <div className="sweet-loading">
            <GridLoader
              css={override}
              sizeUnit={"px"}
              size={40}
              color={"#cadb2a"}
              loading={this.props.placeActionLoading}
            />
          </div>
        )}
        <br />
        <h3>Places</h3>
        {placeList}
        <br />
        <h3>Pages</h3>
        {pageList}
        <DialogBox
          show_modal={this.state.modal_data}
          hide_modal={this.handleCloseModal.bind(this)}
          onSubmit={this.OnDialogSubmit.bind(this)}
        />
        <div className="overlay"></div>
      </div>
    );
  }
}

function indication() {
  return "No records found!";
}
function navigationFormatter(cell, row) {
  if (cell === true) {
    return "Yes";
  } else {
    return "No";
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
  // console.log("State ==========", state);
  return {
    placeActionLoading: state.places.actionsloading,
    pageActionLoading: state.pages.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    pageTypes: Object.values(state.pagetypes.byId),
    places: state.places.places,
    placesDropList: state.places.placesDropList,
    pages: Object.values(state.pages.byId),
  };
}
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(placesActions, dispatch)
)(Places);
